import { Trans, useLingui } from '@lingui/react/macro'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button, Result } from 'antd'
export const Route = createFileRoute('/404')({
  component: NotFound,
})

function NotFound() {
  const { t } = useLingui()
  const navigate = useNavigate()

  return (
    <Result
      status="404"
      title="404"
      subTitle={t`The page you visited does not exist.`}
      extra={
        <Button type="primary" onClick={() => navigate({ to: '/arc' })}>
          <Trans>Back Home</Trans>
        </Button>
      }
    />
  )
}
